import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { User, Store, ArrowRight, CheckCircle2 } from 'lucide-react';
import styles from './registerSelection.module.css';

const RegisterSelection = () => {
    const navigate = useNavigate();
    const { appearences } = useSelector((state) => state.appearences);
    const [bgImage, setBgImage] = useState('/assets/login.png');

    useEffect(() => {
        if (appearences?.loginBanner?.image) {
            const img = new Image();
            img.src = appearences.loginBanner.image;
            img.onload = () => setBgImage(appearences.loginBanner.image);
            img.onerror = () => setBgImage('/assets/login.png');
        } else {
            setBgImage('/assets/login.png');
        }
    }, [appearences?.loginBanner?.image]);

    return (
        <div
            className={styles.loginContainer}
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundAttachment: 'fixed',
                backgroundSize: 'cover',
            }}
        >
            <div className={styles.loginInner}>
                <div className={styles.loginCol1} onClick={() => navigate('/')}>
                    <img src="/assets/logo.png" alt="ElectroWiz Logo" />
                </div>

                <div className={styles.loginCol2}>
                    <div className={styles.loginCard}>
                        <div className={styles.headerArea}>
                            <h2>Join ElectroWiz</h2>
                            <p>Select your account type to get started</p>
                        </div>

                        <div className={styles.selectionGrid}>
                            {/* Customer Option */}
                            <div
                                className={styles.optionCard}
                                onClick={() => navigate('/customerRegn')}
                            >
                                <div className={styles.iconWrapper}>
                                    <User size={32} color="#c084fc" />
                                </div>
                                <h3>Join as Customer</h3>
                                <p className={styles.optionDesc}>
                                    For buyers, engineers, and businesses looking to source electronic components.
                                </p>
                                <ul className={styles.featureList}>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>Browse thousands of electronic parts</span>
                                    </li>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>Create BOM lists & instant RFQ quotes</span>
                                    </li>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>Track orders & manage saved lists</span>
                                    </li>
                                </ul>
                                <button
                                    type="button"
                                    className={`${styles.actionBtn} ${styles.customerBtn}`}
                                >
                                    <span>Register as Customer</span>
                                    <ArrowRight size={18} />
                                </button>
                            </div>

                            {/* Vendor Option */}
                            <div
                                className={styles.optionCard}
                                onClick={() => navigate('/vendorRegn')}
                            >
                                <div className={styles.iconWrapper}>
                                    <Store size={32} color="#c084fc" />
                                </div>
                                <h3>Join as Vendor</h3>
                                <p className={styles.optionDesc}>
                                    For suppliers, manufacturers, and distributors selling electronic stock & inventory.
                                </p>
                                <ul className={styles.featureList}>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>List & showcase your inventory</span>
                                    </li>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>Receive & respond to buyer quotes</span>
                                    </li>
                                    <li>
                                        <CheckCircle2 size={16} className={styles.checkIcon} />
                                        <span>Sell excess inventory directly</span>
                                    </li>
                                </ul>
                                <button
                                    type="button"
                                    className={`${styles.actionBtn} ${styles.customerBtn}`}
                                >
                                    <span>Register as Vendor</span>
                                    <ArrowRight size={18} />
                                </button>
                            </div>
                        </div>

                        <div className={styles.footerArea}>
                            <span>Already have an account? </span>
                            <span className={styles.loginLink} onClick={() => navigate('/login')}>
                                LOGIN
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterSelection;
